var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3372 2.35013L11.4722 5.27098L8.60721 8.19183C8.23271 8.41856 7.80327 8.53843 7.36548 8.53843C6.92769 8.53843 6.49826 8.41856 6.12375 8.19183L0.393813 2.35013C0.141242 2.0896 0 1.74099 0 1.37813C0 1.01527 0.141242 0.666659 0.393813 0.406131C0.515803 0.280477 0.661352 0.180087 0.822149 0.110697C0.982945 0.0413067 1.15584 0.0042751 1.33095 0.00171765C1.50606 -0.000839813 1.67996 0.031127 1.84271 0.095792C2.00547 0.160457 2.15389 0.256553 2.27949 0.378591L2.30379 0.402891L7.36629 5.56096L12.4272 0.402891C12.5494 0.277453 12.6951 0.17732 12.856 0.10821C13.0169 0.0390996 13.1899 0.00236726 13.365 0.000110698C13.5401 -0.00214587 13.7139 0.0301176 13.8766 0.0950582C14.0392 0.159999 14.1875 0.256344 14.3129 0.378591L14.3372 0.402891C14.4669 0.529365 14.57 0.680522 14.6403 0.847455C14.7107 1.01439 14.747 1.19372 14.747 1.37489C14.747 1.55605 14.7107 1.73539 14.6403 1.90232C14.57 2.06925 14.4669 2.22041 14.3372 2.34689",
    fill: "#343434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.3a64037a.svg";
export { ForwardRef as ReactComponent };